import dayjs from 'dayjs';

const isValidDayjs = (value: any) => dayjs(value).isValid();

const formatStartOfDay = (value: any) =>
    value && isValidDayjs(value) ? dayjs(value).startOf('day').toISOString() : undefined;

const formatEndOfDay = (value: any) =>
    value && isValidDayjs(value) ? dayjs(value).endOf('day').toISOString() : undefined;

const formatDate = (value: any) =>
    value && isValidDayjs(value) ? dayjs(value).format('YYYY-MM-DD') : undefined;

export { isValidDayjs, formatStartOfDay, formatEndOfDay, formatDate };
